module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selected) ? _c('div', {
    staticClass: "ui basic segment",
    class: {
      loading: _vm.loading
    }
  }, [_c('div', {
    staticClass: "ui stackable two column grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui rounded fluid image"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl
    }
  }), (_vm.imageUrl) ? _c('div', {
    staticClass: "ui bottom attached label"
  }, [_vm._v(_vm._s(_vm.info ? (_vm.info.imageCaption ? _vm.info.imageCaption : _vm.selected) : 'No caption found.'))]) : _vm._e()])]), _c('div', {
    staticClass: "column",
    style: ([_vm.imageUrl ? '' : 'two wide'])
  }, [(_vm.text) ? _c('p', [_vm._v(_vm._s(_vm.text))]) : _vm._e(), (!_vm.text) ? _c('p', [_vm._v("No Wikipedia article found for "), _c('b', [_vm._v(_vm._s(_vm.selected) + " 😢")])]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f36f0f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WikiSummary.vue
// module id = 236
// module chunks = 1